export const  style = {
      
    minWidth: '300px',
    minHeight: '55px',
    border: '2px solid #7645d9',
    padding: '16px',
    color: '#7645d9',
    fontWeight:"500",
    background: '#fff',
    zIndex:"99999"
    
}

export const iconTheme = {
    primary: '#7645d9',
    secondary: '#fff',
}

export const  position= {
    position: "top-center"
}


export const  zindex= {
    zIndex: "99999"
}